import React from "react";
import styled from "styled-components";
import breakpoints from "../constants/breakpoints";

const VideoContainer = styled.div`
  width: 100%;
  line-height: 0;
  display: flex;
  justify-content: center;
  padding-top: 3em;
  padding-bottom: 2em;
  padding-left: 1em;
  margin-right: -7em;
`;

const VideoInnerContainer = styled.div`
  width: 720px;
  height: 400px;
  min-width: 720px;
  min-height: 450px;
  @media (max-width: ${ breakpoints.desktopMediumHD }px) and (min-width: ${ breakpoints.desktopSmallHD + 1}px) {
     width: 540px;
     height: 384px;
     min-width: 540px;
     min-height: 384px;
  }
  @media (max-width: ${ breakpoints.iPad }px) {
     width: 540px;
     height: 384px;
     min-width: 540px;
     min-height: 384px;
  }
  @media (max-width: ${ breakpoints.xLargePhone }px) {
     width: 360px;
     height: 256px;
     min-width: 360px;
     min-height: 256px;
  }
`;

export {
    VideoContainer,
    VideoInnerContainer,
};
